export const Icons = {
  svg: {
    voucher: 'assets/images/icons/voucher.svg',
    wallet: 'assets/images/icons/icons8-wallet.svg',
    loyalty: 'assets/images/icons/icons8-loyalty.svg',
    nothingFound: 'assets/images/icons/icons8-nothing-found.svg',
    loyaltyTransaction: 'assets/images/icons/loyalty-transaction.svg',
    paymentDefault: 'assets/images/icons/payment-default.svg',
    clickAndCollect: 'assets/images/icons/click-and-collect.svg',
    scanAndGo: 'assets/images/icons/icons8-qr-code.svg',
    heart: 'assets/images/icons/icons8-heart.svg',
    visaCard: 'assets/images/icons/payment-cards/icons8-visa.svg',
    masterCard: 'assets/images/icons/payment-cards/icons8-mastercard.svg',
    chipCard: 'assets/images/icons/payment-cards/icons8-chip-card.svg',
    americanExpressCard: 'assets/images/icons/payment-cards/icons8-american-express.svg',
    maestroCard: 'assets/images/icons/payment-cards/icons8-maestro.svg',
    collectionTime: 'assets/images/icons/icons8-delivery-time.svg',
    hello: 'assets/images/icons/hello.svg',
    clearSearch: 'assets/images/icons/icons8-clear-search.svg',
    time: 'assets/images/icons/icons8-time.svg',
    timeSelected: 'assets/images/icons/icons8-alarm-on.svg',
    history: 'assets/images/icons/icons8-search.svg',
    searchFilled: 'assets/images/icons/icons8-search-filled.svg',
    myCards: 'assets/images/icons/icons8-credit-card.svg',
    account: 'assets/images/icons/icons8-user.svg',
    createAccount: 'assets/images/icons/icons8-task.svg',
    settings: 'assets/images/icons/icons8-setting.svg',
    user: 'assets/images/icons/icons8-user.svg',
    userMale: 'assets/images/icons/icons8-male-user.svg',
    orderHistory: 'assets/images/icons/icons8-order-history.svg',
    logout: 'assets/images/icons/icons8-logout.svg',
    about: 'assets/images/icons/icons8-about.svg',
    timeMachine: 'assets/images/icons/icons8-time-machine.svg',
    help: 'assets/images/icons/icons8-help.svg',
    orderHistoryFilled: 'assets/images/icons/icons8-order-history-filled.svg',
    logoutFilled: 'assets/images/icons/icons8-logout-filled.svg',
    aboutFilled: 'assets/images/icons/icons8-about-filled.svg',
    timeMachineFilled: 'assets/images/icons/icons8-time-machine-filled.svg',
    helpFilled: 'assets/images/icons/icons8-help-filled.svg',
    addToGoogleWalletBtn: 'assets/images/icons/enUS_add_to_google_wallet_wallet-button.svg',
    addToAppleWalletBtn: 'assets/images/icons/US-UK_Add_to_Apple_Wallet_RGB_101421.svg',
    loyaltyPoints: 'assets/images/icons/purse-types/loyalty-points.svg',
    cashPurse: 'assets/images/icons/purse-types/cash-purse.svg',
    freeSpendPurse: 'assets/images/icons/purse-types/free-spend-purse.svg',
    cateredMealPlanPurse: 'assets/images/icons/purse-types/catered-meal-plan-purse.svg',
    subscribedMealPlanPurse: 'assets/images/icons/purse-types/subscribed-meal-plan-purse.svg',
    bursaryPurse: 'assets/images/icons/purse-types/bursary-purse.svg',
    conferenceDelegatePurse: 'assets/images/icons/purse-types/conference-delegate-purse.svg',
    hospitalityOrAccountChargePurse: 'assets/images/icons/purse-types/hospitality-accountcharge-purse.svg',
    studentMealVoucher: 'assets/images/icons/purse-types/student-meal-voucher.svg',
    hiddenCreditPurse: 'assets/images/icons/purse-types/hidden-credit-purse.svg',
    directCardPayment: 'assets/images/icons/purse-types/direct-card-payment.svg',
    star: 'assets/images/icons/icons8-star.svg',
    starFilled: 'assets/images/icons/icons8-star-filled.svg',
    location: 'assets/images/icons/icons8-location.svg',
    walletFilled: 'assets/images/icons/icons8-wallet-filled.svg',
    info: 'assets/images/icons/icons8-info.svg',
  },
  png: {
    nothingFound: 'assets/images/nothing-found.png',
  },
};
